import { Button as UiButton, ButtonNew as UiButtonNew, ButtonProps } from '@jfs/ui-new'
import { ComponentProps, FC } from 'react'
import { View } from 'react-native'

/**
 * Drop-in replacements for the @jfs/ui-new Button / ButtonNew (admin-portal only).
 * Solid dark blue buttons get the same navy -> teal gradient as GradientButton (Search),
 * so every primary action looks the same. All other variants (red, green, white,
 * outlined, etc.) are rendered untouched. The gradient itself lives in assets/index.css.
 */

const BLUE_COLORS = [
  'PRIMARY',
  'BLUE',
  'BRAND_PRIMARY_ACTION',
  'DARK_OCEAN_BLUE',
  'BLUE_SHADE_PRIMARY',
  '#214796',
  '#224896',
  '#0070B6',
  '#4373df',
  '#4e73df',
].map((c) => c.toLowerCase())

const PRIMARY_TYPES = ['primary', 'primaryIcon', 'primarySmall', 'primaryIconSmall', 'primaryFullWidth']

const isBlue = (color: any) =>
  color === undefined || color === null || BLUE_COLORS.includes(String(color).toLowerCase())

const GradientWrap: FC<{ variant: 'new' | 'legacy' }> = ({ variant, children }) => (
  <View {...({ dataSet: { adminBtn: variant } } as any)} style={{ display: 'contents' } as any}>
    {children}
  </View>
)

export const ButtonNew: FC<ButtonProps> = (props) => {
  const { type = 'primary', color, disabled, disabledColor } = props
  const useGradient =
    !Array.isArray(type) &&
    PRIMARY_TYPES.includes(type) &&
    !Array.isArray(color) &&
    isBlue(color) &&
    !(disabled && disabledColor)
  const button = <UiButtonNew {...props} />
  return useGradient ? <GradientWrap variant={'new'}>{button}</GradientWrap> : button
}

type LegacyButtonProps = ComponentProps<typeof UiButton>

export const Button: FC<LegacyButtonProps> = (props) => {
  const { type = 'primary', color } = props
  const useGradient = (type === 'primary' || type === 'SecondaryWithBg') && isBlue(color)
  const button = <UiButton {...props} />
  return useGradient ? <GradientWrap variant={'legacy'}>{button}</GradientWrap> : button
}
